let index = -1;

export const sliderV2 = {
  elements: Array.from(
    document.querySelectorAll(".slider--v2 .swiper-container")
  ),
  bindEvents: (el, swiper) => {
    index++;

    jQuery(
      ".slider--v2-multiple [data-slider=" + index + "] .swiper-button-prev"
    ).on("click", function() {
      swiper.slidePrev();
    });

    jQuery(
      ".slider--v2-multiple [data-slider=" + index + "] .swiper-button-next"
    ).on("click", function() {
      swiper.slideNext();
    });
  },
  details: (el) => ({
    // Optional parameters
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 20,
    speed: 600,
    threshold: 10,
    centerInsufficientSlides: false,

    // Navigation arrows
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },

    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // breakpoints: {
    //   1023: {
    //     slidesPerView: 1,
    //     spaceBetween: 40,
    //   },
    //   640: {
    //     slidesPerView: 1,
    //     spaceBetween: 20,
    //   },
    // },
  }),
};
